package one.healthium.pcos.presentation.navigation.today

import androidx.compose.runtime.Composable
import one.healthium.today.ui.pcos.TodayScreen

@Composable
fun TodayContent(
    component: TodayComponent,
) {
    // TODO add specific today for pcos
    TodayScreen(component)
}